/**
 * @generated SignedSource<<9db95f9e36c0631a8b7ec55bac5d1801>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useCustomVocabularySettingValidateCustomVocabularyListMutation$variables = {
  customVocabularyList: ReadonlyArray<string>;
};
export type useCustomVocabularySettingValidateCustomVocabularyListMutation$data = {
  readonly validateCustomVocabularyList: {
    readonly error: string | null;
    readonly valid: boolean;
  } | null;
};
export type useCustomVocabularySettingValidateCustomVocabularyListMutation = {
  response: useCustomVocabularySettingValidateCustomVocabularyListMutation$data;
  variables: useCustomVocabularySettingValidateCustomVocabularyListMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customVocabularyList"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "customVocabularyList",
        "variableName": "customVocabularyList"
      }
    ],
    "concreteType": "ValidateCustomVocabularyList",
    "kind": "LinkedField",
    "name": "validateCustomVocabularyList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "valid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCustomVocabularySettingValidateCustomVocabularyListMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCustomVocabularySettingValidateCustomVocabularyListMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6eb0b255e6a4ad59ababf9e86279c048",
    "id": null,
    "metadata": {},
    "name": "useCustomVocabularySettingValidateCustomVocabularyListMutation",
    "operationKind": "mutation",
    "text": "mutation useCustomVocabularySettingValidateCustomVocabularyListMutation(\n  $customVocabularyList: [String!]!\n) {\n  validateCustomVocabularyList(customVocabularyList: $customVocabularyList) {\n    valid\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "4db2ae7bee1fd6fc13268b10b56feadc";

export default node;
